export default "__VITE_ASSET__DPj3GBMq__"